import {FloatingField} from "@mytour/ui/form";
import {Splitter} from "@mytour/ui/layout";
import {type Control, Controller, type FieldErrors} from "react-hook-form";
import {FormGroup, FormText, Input} from "reactstrap";
import type {WorkerFormData} from "./WorkerForm.js";

interface WorkerAddressSectionProps {
  control: Control<WorkerFormData>;
  errors: FieldErrors<WorkerFormData>;
  hasCustomAddress: boolean;
  onAddressToggle: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function WorkerAddressSection({
  control,
  errors,
  hasCustomAddress,
  onAddressToggle,
}: WorkerAddressSectionProps) {
  return (
    <>
      <FormGroup>
        <div className="form-check form-switch">
          L&apos;intervenant a-t-il un point de départ différent ? &nbsp;
          <Controller
            name="hasCustomAddress"
            control={control}
            render={({field}) => (
              <Input
                type="checkbox"
                id="hasCustomAddress"
                checked={field.value}
                onChange={(e) => {
                  field.onChange(e);
                  onAddressToggle(e);
                }}
              />
            )}
          />
        </div>
        {!hasCustomAddress && (
          <FormText color="muted" className="mt-2">
            Par défaut, la même valeur que le manager sera utilisée.
          </FormText>
        )}
      </FormGroup>

      {hasCustomAddress && (
        <>
          <FloatingField
            name="address.streetAddress"
            label="Adresse"
            control={control}
            error={errors.address?.streetAddress}
            required
          />

          <FloatingField
            name="address.streetAddress2"
            label="Complément d'adresse"
            control={control}
          />

          <Splitter width1={33} width2={65}>
            <FloatingField
              name="address.zipCode"
              label="Code postal"
              control={control}
              error={errors.address?.zipCode}
              required
            />
            <FloatingField
              name="address.city"
              label="Ville"
              control={control}
              error={errors.address?.city}
              required
            />
          </Splitter>

          <FloatingField
            name="address.country"
            label="Pays"
            control={control}
            error={errors.address?.country}
            required
          />
        </>
      )}
    </>
  );
}
